import { createContext, useContext } from 'react'
import { SnackLevel } from '@src/navigation/components/SnackContent'
import { IconName } from '@src/components/base'

interface NavigatorContextInjectedProps {
  showSnack: (
    snackTitle: string,
    snackContent?: string | null,
    level?: SnackLevel,
    iconName?: IconName,
    action?: {
      label: string
      onPress: () => void
    },
    variant?: 'default' | 'redesigned',
  ) => void
  hideSnack: () => void
  enableLoader: () => void
  disableLoader: () => void
}

export const NavigatorContext = createContext<NavigatorContextInjectedProps>({
  enableLoader: () => undefined,
  disableLoader: () => undefined,
} as NavigatorContextInjectedProps)

export const useSnack = () => {
  const { showSnack } = useContext(NavigatorContext) as NavigatorContextInjectedProps

  return showSnack
}

export const useHideSnack = () => {
  const { hideSnack } = useContext(NavigatorContext) as NavigatorContextInjectedProps

  return hideSnack
}
